import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Toast from '../common/Toast/Toast';
import { useAppState } from '../../contexts/appState';
import { allVerticalsParam, getContractTypeVal, getProjectId } from '../../lib/common';
import { GetTickets } from '../../api';
import { useDebounce, useLocalStorage, useSessionStorage } from '../../hooks';
import './Layout.css';
import { DateFilterHeader } from '../common/Header';

export default function DateFilterLayout() {
  const [appState] = useAppState();
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [userDetails] = useSessionStorage('userDetails', '');
  const [page, setPage] = useState(1);
  const [myTicketsLoading, setMyTicketsLoading] = useState(true);
  const projectId = getProjectId();
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const [selectedStatus, setSelectedStatus] = useState('All');
  const [myTicketsData, setMyTicketsData] = useState([]);
  const [totalCnt, setTotalcnt] = useState(0);
  const [ticketId, setTicketId] = useState('');
  const [changeTicket, setChangeTicket] = useState(false);
  const debouncedSearchText = useDebounce(ticketId, 500);
  const [loader, setLoader] = useState(true);
  const startdate = new Date();
  const date = new Date();
  date.setDate(date.getDate() - 30);
  const [datesResp, setDatesResp] = useState({});
  const tempEndDate = `${startdate.getFullYear()}-${startdate.getMonth() + 1}-${startdate.getDate()}`;
  const tempStrtDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  const contractType = getContractTypeVal(projectId);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [_state, _setState] = useState([
    {
      startDate: startdate,
      endDate: date,
      key: 'selection',
    },
  ]);

  const getTicketsData = async (_status = '', reload, status, changeDate = false) => {
    try {
      setMyTicketsLoading(true);
      const docIdObj = {
        docId: projectId === 'genio' ? '' : selectedBusiness?.docid || '',
        createdBy: projectId === 'genio' ? profile?.mobile : '',
        src_typ: projectId === 'csportal' ? 'call,whatsapp,csportal' : '',
        src_mob: contractType === 'user' ? userDetails?.mobile || '' : projectId === 'genio' ? profile?.mobile : '',
        src: 'sales-genio',
      };
      const portalFlag = 1;
      const params = {
        category: 'CS,CCR',
        vertical: contractType === 'user' ? 'USER EXPERIENCE' : allVerticalsParam,
        allocEmpid: '',
        page,
        limit: 10,
        search: docIdObj,
        sortBy: '',
        ticketCreator: '',
        download: 0,
        portalFlag,
        emails: undefined,
        _status: _status || selectedStatus,
        ticketId: status ? '' : ticketId,
        genioMyTicketsFlag: projectId === 'genio' ? 1 : 0,
        grEligible: '',
        sdt: `${startDate || tempStrtDate} 00:00:00`,
        edt: `${endDate || tempEndDate} 23:59:59`,
        src_mob: contractType === 'user' ? userDetails?.mobile || '' : projectId === 'genio' ? profile?.mobile : '',
        projectId,
      };
      const res = await GetTickets(params);
      setDatesResp({
        startDate: res?.startDate,
        endDate: res?.endDate,
      });
      let _ticketData = myTicketsData;

      _ticketData = [];
      setMyTicketsData(_ticketData);
      setTotalcnt(res?.total_cnt || 0);
      if (_status) {
        setPage(1);
        setMyTicketsData(res.data);
      } else if (changeTicket || changeDate) {
        setMyTicketsData(res.data);
      } else {
        const obj = reload ? [...res.data] : [...myTicketsData, ...res.data];
        setMyTicketsData(obj);
      }
      setLoader(false);
      setChangeTicket(false);
      setMyTicketsLoading(false);
    } catch (error) {
      setMyTicketsLoading(false);
      console.log('error', error);
    }
  };
  useEffect(() => {
    if (totalCnt > 9) {
      window.onscroll = () => {
        const scrollEle = document.body.scrollHeight;
        const scrollHeight = scrollEle;
        const totalHeight = window.scrollY + window.innerHeight;
        if (totalHeight >= scrollHeight && page <= Math.ceil(totalCnt / 9)) {
          let _page = page;
          _page += 1;
          setPage(_page);
        }
      };
    }
  });
  useEffect(() => {
    if (page) {
      if (totalCnt > 9) {
        getTicketsData();
      }
    }
  }, [page]);
  useEffect(() => {
    if (startDate && endDate) {
      let _ticketData = myTicketsData;
      _ticketData = [];
      setMyTicketsData(_ticketData);
      setPage(1);
      setLoader(true);
      getTicketsData('', false, '', true);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    const handlegetTicketData = async () => {
      try {
        await getTicketsData();
      } catch (err) {
        console.error('Error: ', err);
      }
    };
    handlegetTicketData();
  }, [debouncedSearchText]);

  return (
    <div className="App">
      <DateFilterHeader
        selectedType="somethingELse"
        style={{ postion: 'fixed' }}
        getTicketsData={getTicketsData}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        _state={_state}
        _setState={_setState}
      />
      <Outlet
        context={{
          getTicketsData,
          myTicketsLoading,
          startDate,
          tempStrtDate,
          endDate,
          tempEndDate,
          loader,
          setLoader,
          setPage,
          setChangeTicket,
          selectedStatus,
          setSelectedStatus,
          ticketId,
          setTicketId,
          myTicketsData,
          datesResp,
        }}
      />
      {appState?.alertSnackbar?.message && <Toast toastMsgObj={appState?.alertSnackbar || {}} />}
    </div>
  );
}
